import { recipe } from '@vanilla-extract/recipes';
import { styleVariants } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';
import { reducedMotion } from '../../theme/media';
import { statusBgTokens } from '../../tokens/orv-quest.tokens';

export const badge = recipe({
  base: {
    display: 'inline-block',
    // flex 메타 줄에서 유일한 수축 가능 아이템이 되면 min-content(한글 1글자)까지 짜부라져
    // 라벨이 세로로 쌓인다. nowrap 이면 min-content 가 라벨 전체 폭이라 그 아래로 못 줄어든다.
    whiteSpace: 'nowrap',
    borderRadius: '4px',
    fontWeight: vars.typography.fontWeight.medium,
    transition: `background-color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}, color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}, border-color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
    '@media': {
      [reducedMotion]: { transition: 'none' },
    },
  },
  variants: {
    size: {
      sm: {
        padding: '2px 6px',
        fontSize: vars.typography.fontSize.xs,
      },
      md: {
        padding: '4px 12px',
        fontSize: vars.typography.fontSize.sm,
        textTransform: 'uppercase' as const,
      },
      lg: {
        padding: '6px 16px',
        fontSize: vars.typography.fontSize.base,
        textTransform: 'uppercase' as const,
      },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

export const statusColors = styleVariants({
  pending: {
    background: statusBgTokens.pending,
    color: vars.bright.status.pending,
    border: `1px solid ${vars.bright.status.pending}`,
  },
  in_progress: {
    background: statusBgTokens.inProgress,
    color: vars.bright.status.info,
    border: `1px solid ${vars.bright.status.info}`,
  },
  locked: {
    background: vars.opacityScale.warningAmber.moderate,
    color: vars.bright.status.warning,
    border: `1px solid ${vars.opacityScale.warningAmber.firm}`,
  },
  completed: {
    background: statusBgTokens.completed,
    color: vars.bright.status.success,
    border: `1px solid ${vars.bright.status.success}`,
  },
  failed: {
    background: statusBgTokens.failed,
    color: vars.bright.status.error,
    border: `1px solid ${vars.bright.status.error}`,
  },
  withdrawn: {
    background: vars.opacityScale.warningAmber.moderate,
    color: vars.bright.status.warning,
    border: `1px solid ${vars.opacityScale.warningAmber.firm}`,
  },
  archived: {
    background: statusBgTokens.archived,
    color: vars.bright.status.archived,
    border: `1px solid ${vars.bright.status.archived}`,
  },
});
